import {
  computeLabel,
  ControlProps,
  isDescriptionHidden,
  OwnPropsOfEnum,
} from "@jsonforms/core";

import { FormMessage } from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import {
  RadioGroupItem,
  RadioGroup as ShadcnRadioGroup,
} from "@/components/ui/radio-group";
import { withJsonFormsEnumProps } from "@jsonforms/react";
import merge from "lodash/merge";

export const RadioGroup = withJsonFormsEnumProps(
  ({
    id,
    label,
    options,
    required = false,
    description,
    errors,
    data,
    uischema,
    visible,
    config,
    enabled,
    path,
    handleChange,
  }: ControlProps & OwnPropsOfEnum) => {
    const appliedUiSchemaOptions = merge({}, config, uischema.options);
    const showDescription = !isDescriptionHidden(
      visible,
      description,
      false,
      appliedUiSchemaOptions.showUnfocusedDescription,
    );
    const isValid = errors.length === 0;

    return (
      <div hidden={!visible} className="space-y-1 mb-8">
        <Label htmlFor={id}>
          {computeLabel(
            label,
            required,
            appliedUiSchemaOptions.hideRequiredAsterisk,
          )}
        </Label>
        <ShadcnRadioGroup
          defaultValue={data}
          onValueChange={(value) => handleChange(path, value)}
          disabled={!enabled}
        >
          {options?.map((option) => (
            <div key={option.label} className="flex items-center space-x-2">
              <RadioGroupItem value={option.value} id={option.value} />
              <Label htmlFor={option.value}>{option.label}</Label>
            </div>
          ))}
        </ShadcnRadioGroup>
        {!isValid ? (
          <FormMessage>{errors}</FormMessage>
        ) : (
          showDescription && <FormMessage>{description}</FormMessage>
        )}
      </div>
    );
  },
);
